module.exports = __webpack_public_path__ + "static/media/flag-not-check.cff7ec63.svg";